var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeartEmptyBlack = function SvgHeartEmptyBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M10.586 18.575c-.102 0-.204-.039-.282-.116l-7.388-7.374c-.025-.025-.046-.052-.063-.081C1.673 9.921 1 8.34 1 6.642 1 3.531 3.239 1 5.993 1c2.126 0 3.883 1.975 4.593 2.908C11.296 2.975 13.053 1 15.179 1c2.754 0 4.993 2.531 4.993 5.642 0 1.417-.47 2.769-1.326 3.818-.019.035-.042.066-.072.094-.068.078-.13.137-.193.196l-.078.076-7.635 7.632c-.077.078-.18.117-.282.117z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartEmptyBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heartEmptyBlack.6ab40e56.svg";
export { ForwardRef as ReactComponent };